<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  },
  
  mounted: function(){

  }
}

</script>

<style>
  #app {
    margin:0;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #222222 !important;
    height: 100%;
  }
</style>
